module.exports = __webpack_public_path__ + "static/media/communicationIcon.85fc8186.png";